// (c) 2023 ABBYY Development, Inc.

import { FC } from 'react';
import { AlertsError, Check } from 'components';
import styled from 'styled-components';

const Wrapper = styled.div<{ fontSize: number }>`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    text-align: right;
    justify-content: center;
    position: relative;
    font-size: ${({ fontSize }) => fontSize}px;
    gap: 1em;
`;

interface Props {
    progress: number;
    fontSize?: number;
    iconSize?: 16 | 20 | 12;
    hasError?: boolean;
}

export const ProgressWithIcon: FC<Props> = ({
    progress,
    fontSize = 14,
    iconSize = 16,
    hasError = false
}) => {
    const flooredProgress = Math.floor(progress);

    return (
        <Wrapper fontSize={fontSize}>
            <span>{flooredProgress}</span>
            {hasError ? (
                <AlertsError size={iconSize} color="error" />
            ) : (
                flooredProgress === 100 && (
                    <Check size={iconSize} color="success" />
                )
            )}
        </Wrapper>
    );
};
